import React from 'react'
import { SearchableFacetedFilter } from '@scentregroup/shared/hub-components/searchable-faceted-filter'
import trackClickEvent from '../../helpers/analytics-utils/track-event'
import { categories, actions } from '../../helpers/analytics-utils/constants'
import styles from './index.module.scss'

export interface WhatsHappeningMultiFilterProps {
  filterOptions: string[]
  selectedOptions: string[]
  onSelectionChange: (selectedOptions: string[]) => void
}

const WhatsHappeningMultiFilter = ({
  filterOptions,
  selectedOptions,
  onSelectionChange,
}: WhatsHappeningMultiFilterProps): JSX.Element | null => {
  const sanitizedFilterOptions = (filterOptions || []).filter(Boolean)

  if (sanitizedFilterOptions.length === 0) {
    return null
  }

  const toggle = (
    selectedOptions: string[],
    { option, isChecked }: { option: string; isChecked: boolean }
  ): void => {
    trackClickEvent(
      categories.WHATS_HAPPENING_FILTERS,
      isChecked ? actions.FILTER_SELECT : actions.FILTER_DESELECT,
      option
    )

    onSelectionChange(selectedOptions)
  }
  return (
    <div className={styles.multiFilters}>
      <SearchableFacetedFilter
        id="WhatsHappeningMultiFilter"
        title="WhatsHappeningMultiFilter"
        optionGroups={[
          {
            options: sanitizedFilterOptions.map(label => ({
              label,
              value: label,
            })),
          },
        ]}
        selectedOptions={selectedOptions}
        onChange={toggle}
      />
    </div>
  )
}

export default WhatsHappeningMultiFilter
